import React, { useState } from 'react'
import { Typography, Divider, Snackbar } from '@material-ui/core'
import {
  ExecutionDetails,
  ExecutionStatus,
} from '../../../shared/src/data/executionDetails'
import { useStyles } from './Styles'
import { serverRoutes } from '../layout/serverRoutes'
import { useFetchFromServer } from '../api/fetchHook'
import { Alert } from '@material-ui/lab'

interface PastExecutionItemProps {
  execution: ExecutionDetails
}

export default function PastExecutionItem({
  execution,
}: PastExecutionItemProps): JSX.Element {
  const styles = useStyles()
  const [message, setMessage] = useState<string | null>(null)
  const [severity, setSeverity] = useState<
    'success' | 'error' | 'warning' | 'info'
  >('info')
  const { fetchJsonFromServer } = useFetchFromServer()
  const handleDownload = async (id: string) => {
    try {
      setMessage(null)
      const result: any = await fetchJsonFromServer(
        serverRoutes.api.executions.results(id),
      )

      if (result.link) {
        window.location.href = result.link
        setMessage('Your download will start shortly.')
        setSeverity('success')
      } else {
        setMessage('No results available yet.')
        setSeverity('warning')
      }
    } catch (error) {
      setMessage('Failed to fetch execution results.')
      setSeverity('error')
    }
  }

  return (
    <div style={{ width: '100%' }}>
      <div style={{ display: 'flex', alignItems: 'center', marginTop: '8px' }}>
        <div style={{ flex: 1 }}>
          <Typography className={styles.executionItemTitle}>
            {execution.projectName || 'No project name'}
          </Typography>
          {execution.phase ? (
            <Typography className={styles.executionItemSubtitle}>
              Phase: {execution.phase}
            </Typography>
          ) : null}
          <Typography className={styles.executionItemSubtitle}>
            Scan id: {execution.scanId}
          </Typography>
          {execution.status === ExecutionStatus.Finished && (
            <div>
              <Typography
                className={styles.downloadLink}
                component='a'
                onClick={() => handleDownload(execution.id)}
              >
                Download results
              </Typography>
              <Snackbar
                open={!!message}
                autoHideDuration={6000}
                onClose={() => setMessage(null)}
              >
                <Alert onClose={() => setMessage(null)} severity={severity}>
                  {message}
                </Alert>
              </Snackbar>
            </div>
          )}
        </div>
      </div>
      <Divider style={{ margin: '8px 0' }} />
    </div>
  )
}
